import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ProcessNew from "./ProcessNew";
import { processesService } from "../../../services/processesService";
import Loading from "../../../components/Loading/Loading";
import { useCustomToast } from "../../../components/CustomToast/CustomToast";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../../constants/routes-path";

const ProcessEdit = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(true);
    const toast = useCustomToast();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await processesService.find(id);
                setInitialData(data);
                setLoading(false);
            } catch (err) {
                toast({ title: t("process.messages.errors.find"), status: "error" });
                redirectToList();
            } finally {
                setLoading(false);
            }
        };

        if (id) fetchData();
    }, [id, toast, navigate]);

    const handleUpdate = async (dto) => {
        try {
            await processesService.update(id, dto);
            toast({ title: t("process.messages.success.update"), status: "success" });
            redirectToList();
        } catch (err) {
            toast({ title: t(err), status: "error" });
        }
    };

    const handleRemoveAttachment = async () => {
        try {
            await processesService.deleteAttachment(id);
            toast({ title: t("process.messages.success.remove-attachment"), status: "success" });
        } catch (err) {
            toast({ title: t("process.messages.errors.remove-attachment"), status: "error" });
            throw err;
        }
    }

    const redirectToList = () => {
        navigate(ROUTES.transportManagementPath + ROUTES.processes);
    };

    return <ProcessNew initialData={initialData} onSubmit={handleUpdate} isEdit loading={loading} onAttachmentRemove={handleRemoveAttachment} />;
};

export default ProcessEdit;
